<template>
  <div class="NVF__Continue">
    <div class="NVF__Continue__Wrapper">
      <div class="NVF__Continue__header">
        <p class="NVF__Continue__header__p1">{{ $t('common-verify-flow.kyc_verify') }}</p>
        <p class="NVF__Continue__header__p2">{{ $t('common-verify-flow.b2') }}</p>
      </div>
      <div class="NVF__Continue__desc1">
        {{ $t('common-verify-flow.starter-desc-3') }}
      </div>
      <div class="NVF__Continue__Content">
        <div class="NVF__Continue__Content__title">
          {{ $t('common-verify-flow.b17') }}
        </div>
        <div div class="NVF__Continue__Content__list">
          <div :key="idx" v-for="idx in Math.ceil(actions.length / 2)" class="NVF__Continue__Content__list__item">
            <div class="NVF__Continue__Content__list__item__left">
              <img src="~/assets/img/sm-icon/right.svg?url" />
              <div>{{ actions[2 * idx - 2] }}</div>
            </div>
            <div v-if="2 * idx - 1 <= actions.length - 1" class="NVF__Continue__Content__list__item__right">
              <img src="~/assets/img/sm-icon/right.svg?url" />
              <div>{{ actions[2 * idx - 1] }}</div>
            </div>
          </div>
        </div>
        <div class="NVF__Continue__SubmitBtn" @click="handleContinue">
          {{ $t('common-verify-flow.senior-verify-btn') }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isLoginedToken, gotoLogin } from '~/common/js/utils';
import messages from '../i18n';
import { usePatchStore } from '~/common/js/patch';
import { axiosClient } from '~/common/js/axios';
export default {
  i18n: { messages },
  name: 'ContinueVerifyLevel2',
  computed: {
    locale() {
      return this.store.locale;
    },
    cid() {
      return this.store.account.cid;
    },
    actions() {
			return [
				this.$t('common-verify-flow.b6-1'),
				this.$t('common-verify-flow.b15'),
				`${this.$t('common-verify-flow.b7')} ${this.kyc24_withdrawal_limit_high} ${
					this.kyc24_withdrawal_limit_high_coin
				} ${this.$t('common-verify-flow.daily')}`,
				this.$t('common-verify-flow.b11'),
				this.$t('common-verify-flow.b8'),
				this.$t('common-verify-flow.b12'),
				this.$t('common-verify-flow.b9'),
				this.$t('common-verify-flow.b14'),
				this.$t('common-verify-flow.b10'),
				this.$t('common-verify-flow.b16'),
			];
		},
  },

  data() {
    return {
      kyc24_withdrawal_limit_high: 100,
			kyc24_withdrawal_limit_high_coin: 'BTC',
    };
  },
  methods: {
    handleContinue() {
      this.$emit('next');
    },
    async getKYCWithdrawalLimitData() {
			const resData = await axiosClient({
				method: 'GET',
				url: '/gw-api/asset/withdraw/cert/limit',
			});

			if (!resData?.success) return;

			this.kyc24_withdrawal_limit_low = resData.data.quotaKyc1
				? resData.data.quotaKyc1
				: this.kyc24_withdrawal_limit_low;
			this.kyc24_withdrawal_limit_high = resData.data.quotaKyc2
				? resData.data.quotaKyc2
				: this.kyc24_withdrawal_limit_high;
			this.kyc24_withdrawal_limit_low_coin = resData.data.defaultCoinKyc1
				? resData.data.defaultCoinKyc1
				: this.kyc24_withdrawal_limit_low_coin;
			this.kyc24_withdrawal_limit_high_coin = resData.data.defaultCoinKyc2
				? resData.data.defaultCoinKyc2
				: this.kyc24_withdrawal_limit_high_coin;
		},
  },
  mounted() {
    if (!isLoginedToken()) {
      gotoLogin(this.$router, this.$route, this.locale);
      return;
    }
    this.getKYCWithdrawalLimitData();
  },
  setup() {
    const { store, commit } = usePatchStore();
    return {
      store,
      commit
    };
  }
};
</script>
<style lang="less">
.day-mode {
	--comp-verify-flow-dialog-continue-color-text: #1a1b1f;
	--comp-verify-flow-dialog-continue-color-text-400: #2b2e36;
	--comp-verify-flow-dialog-continue-color-bd: #eeeeee;
}

.night-mode {
	--comp-verify-flow-dialog-continue-color-text: #ffffff;
	--comp-verify-flow-dialog-continue-color-text-400: #9cb3ba;
	--comp-verify-flow-dialog-continue-color-bd: #9cb3ba66;
}
</style>
<style lang="less">
@import '~/common/css/element-base-type.less';

.NVF__Continue {
	box-sizing: border-box;
	width: 100%;

	// :global {
	//   .sarterVerification-fade-enter-active {
	//     transition: opacity 0.5s;
	//   }
	//   .sarterVerification-fade-enter {
	//     opacity: 0;
	//   }
	// }
	&__Wrapper {
		display: flex;
		flex-direction: column;
		width: 100%;
		// height: 420px;
	}
	&__SubmitBtn {
		width: 100%;
		height: 48px;
		text-align: center;
		font-size: 14px;
		line-height: 48px;
		color: #fff;
		background-color: @blue-base;
		border-radius: 8px;
		font-weight: 500;
		cursor: pointer;
		margin-top: 68px;
	}
}

@media (max-width: 768px) {
	.NVF__Continue {
		padding: 0 1em;
		&__header {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			margin-bottom: 10px;
			align-items: flex-end;
			&__p1 {
				font-size: 1.5em;
				line-height: 1;
				color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
				font-style: normal;
				font-weight: 600;
			}
			&__p2 {
				font-size: 0.7em;
				line-height: 1;
				color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
				font-weight: 500;
				margin-left: 10px;
			}
		}
		&__desc1 {
			margin-top: 0.2em;
			font-style: normal;
			font-weight: 400;
			font-size: 0.7em;
			color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
		}
		&__Content {
			margin-top: 1.5em;
			// margin-bottom: 3em;
			&__title {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				color: var(--comp-verify-flow-dialog-continue-color-text-400, #2b2e36);
			}
			&__list {
				display: flex;
				flex-direction: column;
				margin-top: 1rem;
				&__item {
					display: flex;
					width: 100%;
					height: 2em;
					align-items: center;
					border-bottom: 1px dashed var(--comp-verify-flow-dialog-continue-color-bd, #eeeeee);
					img {
						margin-right: 17px;
						width: 14px;
						height: 12px;
					}

					&__left {
						display: flex;
						align-items: center;
						flex: 1;
						div {
							font-style: normal;
							font-weight: 400;
							font-size: 12px;
							line-height: 38px;
							color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
						}
					}
					&__right {
						display: flex;
						align-items: center;
						flex: 1;
						div {
							font-style: normal;
							font-weight: 400;
							font-size: 12px;
							line-height: 38px;
							color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
						}
					}
				}
			}
		}
	}
}
@media (min-width: 768px) {
	.NVF__Continue {
		&__header {
			display: flex;
			flex-direction: row;
			justify-content: flex-start;
			align-items: flex-end;
			margin-bottom: 10px;
			&__p1 {
				font-size: 24px;
				line-height: 1;
				color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
				font-style: normal;
				font-weight: bold;
			}
			&__p2 {
				margin-left: 10px;
				font-size: 14px;
				color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
				font-weight: 500;
				line-height: 1;
			}
		}
		&__desc1 {
			margin-top: 8px;
			font-style: normal;
			font-weight: 400;
			font-size: 14px;
			color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
		}
		&__Content {
			margin-top: 48px;
			// margin-bottom: 48em;
			&__title {
				font-style: normal;
				font-weight: 400;
				font-size: 14px;
				color: var(--comp-verify-flow-dialog-continue-color-text-400, #2b2e36);
			}
			&__list {
				display: flex;
				flex-direction: column;
				margin-top: 1rem;
				&__item {
					display: flex;
					width: 100%;
					height: 40px;
					align-items: center;
					border-bottom: 1px dashed var(--comp-verify-flow-dialog-continue-color-bd, #eeeeee);
					img {
						margin-right: 17px;
						width: 14px;
						height: 12px;
					}

					&__left {
						display: flex;
						align-items: center;
						flex: 1;
						div {
							font-style: normal;
							font-weight: 400;
							font-size: 12px;
							line-height: 38px;
							color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
						}
					}
					&__right {
						display: flex;
						align-items: center;
						flex: 1;
						div {
							font-style: normal;
							font-weight: 400;
							font-size: 12px;
							line-height: 38px;
							color: var(--comp-verify-flow-dialog-continue-color-text, #1a1b1f);
						}
					}
				}
			}
		}
	}
}
</style>
